import { color_black_light, color_white } from "../../constants/colors";
import { useWindowDimensions } from "../../utils";
import Logo from "../Logo";
import { Link, OnestNormalMed } from "../styled/TextComponents";
import { useI18n } from "../../i18n/I18nProvider";

const Footer = () => {
  const { t } = useI18n();
  const { height: screenHeight, width: screenWidth } = useWindowDimensions();
  const textStyle = {
    fontSize: screenWidth > 800 ? "14px" : "12px",
  };
  return (
    <footer
      style={{
        width: "100%",
        height: screenWidth >= 768 ? "130px" : "auto",
        backgroundColor: color_black_light,
        display: "flex",
        flexDirection: screenWidth >= 768 ? "row" : "column",
        padding: screenWidth >= 768 ? "50px" : "30px",
        justifyContent: "space-between",
        alignItems: screenWidth >= 768 ? "center" : "flex-start",
        boxSizing: "border-box",
        gap: screenWidth >= 768 ? "40px" : "15px",
      }}
    >
      <Logo baseColor={color_white} />
      <div
        style={{
          display: "flex",
          flexDirection: screenWidth > 500 ? "row" : "column",
          gap: screenWidth > 500 ? "20px" : "15px",
          color: color_white,
        }}
      >
        <OnestNormalMed style={textStyle}>
          <Link href={"/offer.html"}>{t("Публичная оферта")}</Link>
        </OnestNormalMed>
        <OnestNormalMed style={textStyle}>
          <Link href={"/privacy-policy.html"}>{t("Политика конфиденциальности")}</Link>
        </OnestNormalMed>
        <OnestNormalMed style={textStyle}>
          <Link href={"/personal-data-agreement.html"}>
            {t("Согласие на обработку данных")}
          </Link>
        </OnestNormalMed>
        <OnestNormalMed style={textStyle}>
          <Link
            href="https://speakid.ru/blog/"
            target="_blank"
            rel="noreferrer"
          >
            {t("Блог")}
          </Link>
        </OnestNormalMed>
        <OnestNormalMed style={textStyle}>
          <div style={{ color: color_white }}>© SPEAKID, 2026</div>
        </OnestNormalMed>
      </div>
    </footer>
  );
};

export default Footer;
